import styled, { css } from 'styled-components';

const sizeObject = {
  small: '30px',
  medium: '80px',
  large: '120px',
};

export const Loading = styled.div<{ $height: string; $fullScreen: boolean }>`
  width: 100%;
  min-height: ${({ $height }) => $height};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $fullScreen }) =>
    $fullScreen
      ? css`
          position: absolute;
          inset: 0 0 0 0;
          z-index: 100;
          // dont use color of theme because get permissions needs full screen loading that render before theme
          background: #fff;
        `
      : null}
`;
Loading.defaultProps = {
  $height: '300px',
};

export const Svg = styled.svg<{ $size: 'small' | 'medium' | 'large' }>`
  width: ${({ $size }) => sizeObject[$size]};
`;
Svg.defaultProps = {
  $size: 'medium',
};
